import logger from '@/utils/logger';

const STORAGE_KEY = 'ui_preferences';
const LEGACY_UI_MODE_KEY = 'ui_mode_preference';
const LEGACY_PAGE_WINDOW_KEY = 'page_window_mode_preference';

export const UI_MODE_OPTIONS = ['default', 'compact'];
export const PAGE_WINDOW_MODE_OPTIONS = ['single', 'multi'];

export const DEFAULT_UI_PREFERENCES = Object.freeze({
  uiMode: 'compact',
  pageWindowMode: 'multi',
});

export function normalizeUIPreferences(input) {
  const normalized = {
    uiMode: DEFAULT_UI_PREFERENCES.uiMode,
    pageWindowMode: DEFAULT_UI_PREFERENCES.pageWindowMode,
  };

  if (!input || typeof input !== 'object') {
    return normalized;
  }

  if (UI_MODE_OPTIONS.includes(input.uiMode)) {
    normalized.uiMode = input.uiMode;
  }

  if (PAGE_WINDOW_MODE_OPTIONS.includes(input.pageWindowMode)) {
    normalized.pageWindowMode = input.pageWindowMode;
  }

  return normalized;
}

function readLegacyPreferences() {
  const legacy = normalizeUIPreferences(null);
  let foundLegacy = false;

  try {
    const legacyUiMode = localStorage.getItem(LEGACY_UI_MODE_KEY);
    if (UI_MODE_OPTIONS.includes(legacyUiMode)) {
      legacy.uiMode = legacyUiMode;
      foundLegacy = true;
    }

    const legacyPageWindowMode = localStorage.getItem(LEGACY_PAGE_WINDOW_KEY);
    if (PAGE_WINDOW_MODE_OPTIONS.includes(legacyPageWindowMode)) {
      legacy.pageWindowMode = legacyPageWindowMode;
      foundLegacy = true;
    }
  } catch (error) {
    logger.error('Error reading legacy UI preferences:', error);
  }

  return foundLegacy ? legacy : null;
}

function removeLegacyPreferenceKeys() {
  try {
    localStorage.removeItem(LEGACY_UI_MODE_KEY);
    localStorage.removeItem(LEGACY_PAGE_WINDOW_KEY);
  } catch (error) {
    logger.error('Error removing legacy UI preference keys:', error);
  }
}

export function getCachedUIPreferences() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      return normalizeUIPreferences(JSON.parse(saved));
    }

    const legacyPreferences = readLegacyPreferences();
    if (legacyPreferences) {
      cacheUIPreferences(legacyPreferences);
      removeLegacyPreferenceKeys();
      return legacyPreferences;
    }
  } catch (error) {
    logger.error('Error loading cached UI preferences:', error);
  }

  return normalizeUIPreferences(null);
}

export function cacheUIPreferences(preferences) {
  const normalized = normalizeUIPreferences(preferences);

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
    removeLegacyPreferenceKeys();
  } catch (error) {
    logger.error('Error caching UI preferences:', error);
  }

  return normalized;
}
